<template>
   <div class="form-group">
      <label
         for="ip_Fname"
         :class="['label-overlay', { active: !isNotEmpty(form.fname) }]"
         @click="switchLabel($event)"
      >
         First Name
      </label>
      <input
         id="ip_Fname"
         v-model.trim="form.fname"
         type="text"
         class="form-control"
         name="firstname"
         :class="[{ 'is-invalid': isValidFname.isInvalid }, { 'is-valid': isValidFname.isValid }]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateFnameData();
            initiatedType();
         "
      />
      <div class="invalid-feedback">Who do we say hi to?</div>
      <div class="valid-feedback">Good first name.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';

export default {
   name: 'FnameComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidFname: {
            isInvalid: false,
            isValid: false,
         },
         form: {
            fname: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         this.form.fname = '';
      }
   },
   methods: {
      validateFnameData() {
         this.isValidFname.isValid = !this.isNotEmpty(this.form.fname);
         this.isValidFname.isInvalid =
            this.$parent.attemptSubmit && this.isNotEmpty(this.form.fname);
      },

      reset() {
         this.isValidFname.isInvalid = false;
         this.isValidFname.isValid = false;
         this.form.fname = '';
      },

      initiatedType() {
         if (this.form.fname !== '') {
            this.userProfileTracker.information({ fname: this.form.fname });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;

            this.tracker(this.options.mixpanelEve, {
               ...(this.options.fname && { Name: this.options.fname }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
